export default "__VITE_ASSET__B$fYJrAH__"